import OfflineMode from "@/pages/OfflineMode";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/_app/offline-mode")({
	component: OfflineMode,
});

